import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import SalesPointForm from 'Services/ServiceProviderManagement/Features/SalesPoint/Components/SalesPointForm'
import { SELECTED_SALES_POINT_PARAMETER_KEY } from 'Services/ServiceProviderManagement/Features/SalesPoint/Hooks/useSalesPointsWithParams'
import { useGetSingleSalesPointQuery } from 'Services/ServiceProviderManagement/Features/SalesPoint/salesPointApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { SERVICE_PROVIDER_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function SalesPointEditPage() {
  const baseUrl = `${SERVICE_PROVIDER_MANAGEMENT_ROOT_URL}/sales-points`
  const { id } = useParams()
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_SALES_POINT_PARAMETER_KEY}=${id}`,
  )
  const { data: singleSalesPoint, isLoading } = useGetSingleSalesPointQuery(
    id ?? '',
    { skip: !id },
  )

  const breadcrumbs = [
    {
      title: t`Home`,
      link: SERVICE_PROVIDER_MANAGEMENT_ROOT_URL,
    },
    {
      title: t`Sales points`,
      link: baseUrl,
    },
    {
      title: singleSalesPoint ? singleSalesPoint.name : '',
    },
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit sales point`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <SalesPointForm
          salesPoint={singleSalesPoint}
          successBaseUrl={previousLocation}
        />
      </WithLoader>
    </Box>
  )
}
